import Vue from 'vue';
import type VueRouter from 'vue-router';
import { Module, ModuleOptions } from '@/modules/ctx-dashboard';
import { Port } from '@/modules/shared/Port';
import { WidgetRepositoryImpl } from './WidgetRepositoryImpl';
import { PortfolioRepositoryImpl } from './PortfolioRepositoryImpl';
import { DashboardRepositoryImpl } from './DashboardRepositoryImpl';
import { LicenseRepositoryImpl } from './LicenseRepositoryImpl';
import { GeneratorRepositoryImpl } from './GeneratorRepositoryImpl';
import { DashboardTemplateRepositoryImpl } from './DashboardTemplateRepositoryImpl';
import { DefaultUserRepository } from '../default/DefaultUserRepository';

let initialized = false;

export function registerModule(router: VueRouter): void {
    if (initialized) {
        return;
    }
    initialized = true;
    Vue.use<ModuleOptions>(Module, {
        router: router,
        widgetRepository: new WidgetRepositoryImpl({
            metrics: Port.metrics,
            widgets: Port.widgets,
            accounting: Port.accounting,
            parks: Port.parks,
            generators: Port.generators,
            portfolios: Port.portfolios,
            templates: Port.widgetTemplates,
            i18n: Port.localizations,
        }),
        portfolioRepository: new PortfolioRepositoryImpl({
            portfolios: Port.portfolios,
            generators: Port.generators,
        }),
        dashboardRepository: new DashboardRepositoryImpl({
            dashboards: Port.dashboards,
            reporting: Port.reports,
        }),
        dashboardTemplatesRepository: new DashboardTemplateRepositoryImpl({
            dashboards: Port.dashboards,
            dashboardsTemplates: Port.dashboardTemplates,
            metrics: Port.metrics,
            auth: Port.auth,
            users: Port.users,
        }),
        licenseRepository: new LicenseRepositoryImpl({
            license: Port.license,
            metrics: Port.metrics,
        }),
        userRepository: new DefaultUserRepository({
            license: Port.license,
            auth: Port.auth,
        }),
        generatorRepository: new GeneratorRepositoryImpl({
            generators: Port.generators,
            parks: Port.parks,
            portfolios: Port.portfolios,
        }),
    });
}
